(function ($) {
  'use strict';
  this.StravaUci23 = function () {};
}).bind(window)(jQuery);
